import { useEffect, useState, useCallback } from "react";
import { sfx } from "../helpers/sfx";

export type Toast = {
  id: number;
  title: string;
  body?: string;
  emoji?: string;
  variant?: "success" | "info" | "warn";
};

let listeners: ((t: Toast) => void)[] = [];
let id = 0;

export function pushToast(t: Omit<Toast, "id">) {
  id += 1;
  const toast: Toast = { id, ...t };
  listeners.forEach((l) => l(toast));
  sfx.toast();
}

export function Toaster() {
  const [items, setItems] = useState<Toast[]>([]);

  const remove = useCallback((tid: number) => {
    setItems((prev) => prev.filter((t) => t.id !== tid));
  }, []);

  useEffect(() => {
    const onPush = (t: Toast) => {
      setItems((prev) => [...prev, t]);
      setTimeout(() => remove(t.id), 4200);
    };
    listeners.push(onPush);
    return () => {
      listeners = listeners.filter((l) => l !== onPush);
    };
  }, [remove]);

  return (
    <div className="toaster">
      {items.map((t) => (
        <div
          key={t.id}
          className={"toast toast-" + (t.variant ?? "info")}
          onClick={() => remove(t.id)}
          role="status"
        >
          {t.emoji && <span className="toast-emoji">{t.emoji}</span>}
          <div className="toast-text">
            <div className="toast-title">{t.title}</div>
            {t.body && <div className="toast-body">{t.body}</div>}
          </div>
        </div>
      ))}
    </div>
  );
}
